/** API client for random per-section admin question-set archives. */

import { apiPost } from './apiUtils';
import { saveBlobAsDownload } from './downloadUtils';

export type QuestionSetModule = 'reading' | 'listening' | 'writing' | 'speaking';

export interface QuestionSetExtractionRequest {
  readonly level: string;
  readonly modules: readonly QuestionSetModule[];
  readonly contextsPerSection: number;
}

function archiveFilename(request: QuestionSetExtractionRequest): string {
  const stamp = new Date().toISOString().replace(/[:.]/g, '-');
  return `question-set-${request.level.toLowerCase()}-${stamp}.zip`;
}

export async function requestQuestionSetExtraction(
  request: QuestionSetExtractionRequest,
): Promise<Blob> {
  const blob = await apiPost<Blob>(
    '/admin/question-set-extractions',
    request,
    {
      responseType: 'blob',
      errorMessage: 'Failed to extract question set',
      context: 'requestQuestionSetExtraction',
      throwOnError: true,
      suppressErrorToast: true,
    },
  );
  if (!blob) {
    throw new Error('Failed to extract question set');
  }
  return blob;
}

export async function downloadQuestionSetExtraction(
  request: QuestionSetExtractionRequest,
): Promise<void> {
  const blob = await requestQuestionSetExtraction(request);
  saveBlobAsDownload(blob, archiveFilename(request));
}
